import { render, staticRenderFns } from "./package.vue?vue&type=template&id=5aa4ee9e&scoped=true"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"
import style0 from "./package.vue?vue&type=style&index=0&id=5aa4ee9e&prod&lang=less&scoped=true"
import style1 from "./package.vue?vue&type=style&index=1&id=5aa4ee9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4ee9e",
  null
  
)

export default component.exports